import {Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {StepperComponent} from "../../../../util/design/stepper/stepper.component";
import {CdkStep} from "@angular/cdk/stepper";

@Component({
  selector: 'app-loi-check-stepper',
  templateUrl: './loi-check-stepper.component.html',
  styleUrls: ['./loi-check-stepper.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    StepperComponent,
    CdkStep
  ]
})
export class LoiCheckStepperComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);


  @Input() selectedStep = 0;
  @Output() selectedStepChange = new EventEmitter<number>();

  @Input() isCheckView: boolean = false;
  @Input() nextStepAllowed: boolean = false;
  @Input() previousStepAllowed: boolean = false;
  @Input() linear: boolean = true;
  @Input() detailCheckLabel: string = 'LOI-Check';

  @Output() changeDrivenEvent = new EventEmitter<number>();

  ngOnInit(): void {
  }

  changeStep(index: number): void {
    this.selectedStep = index;
    this.selectedStepChange.emit(this.selectedStep);
    this.changeDrivenEvent.emit(index);
  }
}
